import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnDestroy,
} from '@angular/core';
import { UserSchema } from 'src/app/core';
import { NotificationService } from 'src/app/feature/services';
import { AppNotification } from 'src/app/shared';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-notification-indicator',
  templateUrl: './notification-indicator.component.html',
  styleUrls: ['./notification-indicator.component.sass'],
})
export class NotificationIndicatorComponent implements OnInit, OnDestroy {
  @Input('user') user!: UserSchema;

  private subsink = new SubSink();
  public notifications!: AppNotification[];

  constructor(private notificationService: NotificationService) {}
  ngOnInit(): void {
    this.subsink.sink = this.notificationService
      .getNotifications$()
      .subscribe();
    this.subsink.sink = this.notificationService.status$.subscribe((data) => {
      this.notifications = data;
    });
  }

  notificationsValid(): boolean {
    return !!this.notifications && !!this.notifications.length;
  }

  public getUnseenNotificationsCount() {
    return this.notifications.filter((filter) => !filter.seen).length;
  }

  ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }
}
